var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeaderBase',[_c('div',{staticClass:"flex items-center shrink header-title w-1/5 cursor-pointer",on:{"click":function($event){return _vm.$router.push({
      name: 'objects',
    })}}},[_c('span',{staticClass:"arrow arrow-l arrow-primary"}),_c('b',[_vm._v("Добавление объекта")])]),_c('div',{staticClass:"shrink flex-container flex-dir-row align-center"})])}
var staticRenderFns = []

export { render, staticRenderFns }